import { render, staticRenderFns } from "./tiga-notice.vue?vue&type=template&id=ab868154&scoped=true"
import script from "./tiga-notice.vue?vue&type=script&lang=js"
export * from "./tiga-notice.vue?vue&type=script&lang=js"
import style0 from "./tiga-notice.vue?vue&type=style&index=0&id=ab868154&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab868154",
  null
  
)

export default component.exports